import React from 'react';

export default class PartyDetailsHeader extends React.Component {
	constructor(props) {
		super(props);
	}

	countGuestStatus(status) {
		let guests = this.props.selectedEventDetails.guests;
		let count = 0;
		guests.forEach(g => {
			if (g.status === status) {count++;}
		});
		return count;
	}

	render() {
		if (this.props.selectedEventDetails && !this.props.selectedEventDetails.account) return null
		//this button was removed with TFS39857 until we are ready to work on Incentives.
		//<button id="shopHostRewardsButton" className="bookPartyBtn" disabled={this.props.selectedEventDetails.eventStatus != 'Closed'} data-toggle="tooltip" data-original-title="Host shopping is available once party has closed.">{this.props.resources["PWS.MyAccount.PartyDetailsShopRewardsButton"]}</button>
		return (
			<div className="animate-in">
				<div className="col-sm-6 clearfix">
					<div className="party-header-title"><strong>{this.props.selectedEventDetails.name}</strong></div>
					<div><span className="sidenote">({this.props.selectedEventDetails.code})</span></div>
					<div className="party-header-status">
						{this.props.resources["PWS.MyAccount.PartyDetailsPartyStatusLabel"]}: <span className={'party-header-status-' + this.props.selectedEventDetails.eventStatus.toLowerCase()}>{this.props.resources[`PWS.MyAccount.EventStatus${this.props.selectedEventDetails.eventStatus}`]}</span>
					</div>
					<div className="party-header-stats totalSales" style={{display: 'none'}}>
						{this.props.resources["PWS.MyAccount.PartyDetailsPartyTotalLabel"]}: <span className="party-header-stats-amount">{this.props.selectedEventDetails.totalEventSales != null ? this.props.selectedEventDetails.totalEventSales.displayValue : "---"}</span>&nbsp;&nbsp;

					</div>
				</div>

				<div className="col-sm-6 clearfix">
					<div className="party-header-stat">
						{this.props.resources["PWS.MyAccount.PartyDetailsAcceptedLabel"]}
						<span className="badge pie-color-1">{this.countGuestStatus('ATT')}</span>
					</div>
					<div className="party-header-stat">
						{this.props.resources["PWS.MyAccount.PartyDetailsDeclinedLabel"]}
						<span className="badge pie-color-2">{this.countGuestStatus('DCL')}</span>
					</div>
					<div className="party-header-stat">
						{this.props.resources["PWS.MyAccount.PartyDetailsNoReplyLabel"]}
						<span className="badge pie-color-3">{this.countGuestStatus('INV')}</span>
					</div>
				</div>
			</div>
		)
	}
}



// WEBPACK FOOTER //
// ./../../Deploy/PWS/ViewModels/Components/MyAccount/HostPortal/PartyDetailsHeader.js